<div class="dash">
    <!-- Profile Section -->
    <div class="profile-section">

        <!-- Show spinner while loading -->
        <div *ngIf="isLoadingProfile" class="spinner"></div>

        <div class="edit-icon-container">
        <img src="assets/images/health/icons/Editicon.svg" style="cursor: pointer;" (click)="onEditHealth()"/>
        </div>
      
        <!-- <img *ngIf="profileImg;" class="avatar" [src]="profileImg" alt="Profile" />
        <img *ngIf="!profileImg" class="avatar" src="assets/images/profile.png" alt="Profile Placeholder" /> -->

        <!-- Profile Section -->
        <div class="avatar-wrapper" *ngIf="!isLoadingProfile">
          <img *ngIf="profileImg" class="avatar" [src]="profileImg" alt="Profile" />
          <!-- If no profile image, show initials -->
          <div *ngIf="!profileImg" class="avatar avatar-text">
            {{ getInitials(profileData?.firstName) }}
          </div>
        </div>
        <h4 class="profile-name">{{ profileData?.firstName }} {{ profileData?.lastName }}</h4>
        <!-- Profile Section -->

      <div class="profile-stats">
        <div class="stat-pair">
          <span style="font-weight:600">Height ({{ profileData?.heightUnit }}):</span><b>{{profileData?.height}}</b>
        </div>
        <div class="stat-pair">
          <span style="font-weight:600">Weight ({{profileData?.weigthtUnit}}):</span><b>{{profileData?.weight}}</b>
        </div>
      </div>
      <div class="profile-stats">
        <div class="stat-pair">
          <span style="font-weight:600">Blood Group:</span><b>{{profileData?.bloodGroup}}</b>
        </div>
        <div class="stat-pair">
          <span style="font-weight:600">Ethnicity:</span><b>{{profileData?.ethnicity}}</b>
        </div>
      </div>
      <div class="profile-stats">
        <div class="stat-pair">
          <span style="font-weight:600">BMI (Body Mass Index):</span><b>{{profileData?.bmi}}</b>
        </div>
      </div>
    </div>

    <!-- Grid of Cards -->
    <div class="card-grid">
      <div class="info-card" (click)="checkHealthUpdates('medication')">
        <i class="fas fa-plus plus-icon" (click)="handlePlusClick($event,'medication')"></i>
        <img src="assets/images/medicine.png"/>
        <div class="card-title">Medication</div>
        <p class="card-datas" *ngIf="!medication || medication === 0">No medication(s) added yet...</p>
        <p class="card-datas" *ngIf="medication">{{medicationCount}} medication{{medicationCount > 1 ? '(s)' : '(s)'}} added</p>
      </div>
      <div class="info-card" (click)="checkHealthUpdates('devices')">
        <i class="fas fa-plus plus-icon" *ngIf="devicecount < 5" (click)="handlePlusClick($event,'device')"></i>
        <img src="assets/images/weight-loss.png"/>
        <div class="card-title">Apps & Devices</div>
        <p class="card-datas" *ngIf="!devicecount || devicecount === 0">No connected devices yet...</p>
        <p class="card-datas" *ngIf="devicecount">{{devicecount}} device{{devicecount > 1 ? '(s)' : '(s)'}} connected</p>
      </div>
      <div class="info-card" (click)="checkHealthUpdates('profile/insurance')">
        <i class="fas fa-plus plus-icon" (click)="handlePlusClick($event,'insurance')"></i>
        <img src="assets/images/medical.png"/>
        <div class="card-title">Insurance</div>
        <p class="card-datas" *ngIf="!insurance || insurance === 0">No insurance(s) added yet...</p>
        <p class="card-datas" *ngIf="insurance">{{insurance}} insurance{{insurance > 1 ? '(s)' : '(s)'}} added</p>
      </div>
      <div class="info-card" (click)="checkHealthUpdates('care-plan')">
        <!-- <i class="fas fa-plus plus-icon" [routerLink]="['/health/care-plan', careplanid]"></i> -->
        <img src="assets/images/careplan.png"/>
        <div class="card-title">Care Plan</div>
        <p class="card-datas" *ngIf="!careplan || careplan === 0">No targets added yet...</p>
        <p class="card-datas" *ngIf="careplan">{{careplan}} care plan added</p>
         <!-- <p class="card-datas" *ngIf="careplan">Total goal count: {{totalGoals}} goal(s) added</p> -->
      </div>
      <!-- Health Log Card - Fixed Navigation -->
    <!-- Health Log Card - Updated with proper click handler -->
    <div class="info-card full-width health-log-card" 
         (click)="onHealthLogClick()" 
         style="cursor: pointer; transition: transform 0.2s ease, box-shadow 0.2s ease;"
         title="Click to view your health activity timeline"
         onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(0,0,0,0.15)'"
         onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 8px rgba(0,0,0,0.1)'">
      <div class="card-title">
        <div class="Footer-header">
          <img class="imghel" src="assets/images/health/homeimg/bookheal.svg" alt="Health Log Icon"/> 
          <span>Health Log</span>
        </div>
      </div>
      <p class="card-datas">Track your daily health activities right here for better insights.</p>
      <div class="log-update">
        <a>Last updated {{lastUpdated}} <i class="fas fa-chevron-right"></i></a>
      </div>
    </div>

      <!-- Immunization Card -->
      <div class="info-card" (click)="checkHealthUpdates('profile/immunization')">
        <i class="fas fa-plus plus-icon" (click)="handlePlusClick($event,'immunization')"></i>
        <img class="imghel" src="assets/images/health/healthlogico/addimmu.svg" />
        <div class="card-title">Immunization</div>
        <p class="card-datas" *ngIf="!immunization || immunization === 0">No immunization(s) added yet...</p>
        <p class="card-datas" *ngIf="immunization">{{immunization}} immunization{{immunization > 1 ? '(s)' : '(s)'}} added</p>
      </div>

      <!-- Family History Card -->
      <div class="info-card" (click)="checkHealthUpdates('profile/familyhistory')">
        <i class="fas fa-plus plus-icon" (click)="handlePlusClick($event,'familyhistory')"></i>
        <img class="imghel" src="assets/images/health/healthlogico/familyhispng.png" />
        <div class="card-title">Family History</div>
        <p class="card-datas" *ngIf="!famhistory || famhistory === 0">No family history added yet...</p>
        <p class="card-datas" *ngIf="famhistory">{{famhistory}} family history{{famhistory > 1 ? '(s)' : '(s)'}} added</p>
      </div>

      <!-- Allergy Card -->
      <div class="info-card" (click)="checkHealthUpdates('profile/allergy')">
        <i class="fas fa-plus plus-icon" (click)="handlePlusClick($event,'allergy')"></i>
        <img class="imghel" src="assets/images/health/icons/allergies 1(1).svg" />
        <div class="card-title">Allergy</div>
        <p class="card-datas" *ngIf="!allergies || allergies === 0">No allergy added yet...</p>
        <p class="card-datas" *ngIf="allergies">{{allergies}} allergy{{allergies > 1 ? 'ies' : 'y'}} added</p>
      </div>
            
      <!-- Medical Conditions Card -->
      <div class="info-card" (click)="checkHealthUpdates('profile/medicalcondition')">
        <i class="fas fa-plus plus-icon" (click)="handlePlusClick($event,'medicalcondition')"></i>
         <img class="imghel" src="assets/images/health/icons/med-rep.png" />
        <div class="card-title">Medical Conditions</div>
        <p class="card-datas" *ngIf="!medcondition || medcondition === 0">No medical condition(s) added yet...</p>
        <p class="card-datas" *ngIf="medcondition">{{medcondition}} medical condition{{medcondition > 1 ? '(s)' : '(s)'}} added</p>
      </div>

    </div>
</div>
<div class="health-container" *ngIf="showCarePlan">
      <app-care-plan></app-care-plan>
      <button (click)="backToHealth()">← Back</button>
</div>
<!-- <div class="health-container" *ngIf="showMedication && medication">
  <app-medication></app-medication>
  <button class="back-button" >← Back to Health</button>
</div> -->
